<div class='container-splitview'>
    <div class='container-view' [ngClass]="{'displayNone':loadRendering }">
        <div class='iframe-container'>
            <iframe id='viewLink' loading='lazy'></iframe>
        </div>
    </div>
    <ng-container *ngIf="loadRendering">
        <div class='container-loader'>
            <app-loader class="loader" [loading]="loadRendering" [progress]="progress"> </app-loader>
        </div>
    </ng-container>

</div>